function appendSortToPaginationLinks() {
    let sortBy = getUrlVars()['sort_by'];
    if (sortBy) {
        let $pageLinks = $('#pagination .page a');
        $pageLinks.each(function () {
            $(this).prop('href', function () {
                return $(this).prop('href') + '&sort_by=' + sortBy;
            })
        })
    }
}

appendSortToPaginationLinks();
